import React from 'react';
import styles from './TaskHeader.module.css';
import { Reward } from '../../../../Components/Reward/Reward';

interface RewardItem {
  type: string;
  amount: number;
}

interface TaskHeaderProps {
  title: string;
  description: string;
  image: string;
  centerIcon: string;
  rewards?: RewardItem[];
  isQuest?: boolean;
  groupType?: string;
}

export const TaskHeader: React.FC<TaskHeaderProps> = ({ 
  title, 
  description, 
  image, 
  centerIcon, 
  rewards, 
  isQuest = false,
  groupType
}) => {
  const centerIconClass = `${styles.centerIcon} ${groupType ? styles[`centerIcon_${groupType}`] : ''}`;
  const centerIconWrapperClass = `${styles.centerIconWrapper} ${groupType ? styles[`centerIconWrapper_${groupType}`] : ''}`;
  
  return (
    <div className={styles.header}>
      <div className={styles.imageContainer}>
        <div className={styles.imageWrapper}>
          <img src={image} alt={title} className={styles.image + ' ' + (rewards ? styles.image_quest : '')} />
        </div>
        
          <div className={centerIconWrapperClass + ' ' + (rewards ? styles.centerIconWrapper_quest : '')}>
            <img src={centerIcon} alt="" className={centerIconClass} />
          </div>
        
      </div>
      <div className={styles.textContent + ' ' + (rewards ? styles.textContent_quest : '')}>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.description}>{description}</p>
        
        {isQuest && rewards && rewards.length > 0 && (
            <div className={styles.rewardsList}>
              {rewards.map((reward, index) => (
                <div key={index} className={styles.rewardItem}>
                  <Reward 
                    type={reward.type.toLowerCase() as 'dc' | 'ticket'} 
                    amount={reward.amount} 
                  />
                </div>
              ))}
            </div>
        )}
      </div>
    </div>
  );
};